<template>
  <div>
    <h3 class="pr-3"></h3>
    <div class="report-header">
      <filter-dialog
        @apply="$emit('refreshFilter')"
        ref="filterDialog"
        @printReport="$emit('print', arguments[0])"
      />
      <!-- <v-btn color="info" fab small @click="$emit('print')">
        <v-icon>print</v-icon>
      </v-btn> -->
    </div>
  </div>
</template>

<script>
import FilterDialog from "./FilterDialog";
export default {
  components: {
    FilterDialog
  },
  props: {
    contact: {
      type: String
    }
  }
};
</script>

<style scoped>
.header {
  text-align: center;
}
.report-info {
  display: flex;
  justify-content: space-between;
}
.report-header {
  display: flex;
}
</style>
